import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';

const GroupLocation = ({ location }) => {
    const [address, setAddress] = useState(null);

    useEffect(() => {
        if (location?.latitude && location?.longitude) {
            fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${location.latitude}&lon=${location.longitude}`, {
                headers: {
                    'User-Agent': 'TuApp/1.0 (tucorreo@ejemplo.com)'
                }
            })
            .then(res => res.json())
            .then(data => {
                setAddress(data.display_name);
            })
            .catch(err => {
                console.error("Error en geocoding:", err);
            });
        }
    }, [location]);

    if (!location) return null;

    return (
        <Typography variant="body1" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            📍
            <Box component="span" sx={{ ml: 1, fontWeight: 'medium' }}>
                {address 
                    ? address 
                    : `Lat: ${location.latitude.toFixed(2)}, Lon: ${location.longitude.toFixed(2)}`
                }
            </Box>
        </Typography>
    );
};

export default GroupLocation;
